import React from 'react';

interface RandomCompaniesProgressProps {
  totalCompanies: number;
  votedCount: number;
}

export const RandomCompaniesProgress: React.FC<RandomCompaniesProgressProps> = ({
  totalCompanies,
  votedCount
}) => {
  if (totalCompanies === 0) return null;

  const allVoted = votedCount === totalCompanies;

  return (
    <div className="text-center text-sm text-slate-400">
      {totalCompanies} companies discovered • Voted on {votedCount} of {totalCompanies}
      {allVoted && (
        <div className="text-green-400 mt-1">
          ✓ All companies voted on! Search for more to continue building your view.
        </div>
      )}
    </div>
  );
}; 